module.exports = __webpack_public_path__ + "2cf100ecfcb6521a20c639377b1df978.svg";